import React, { useState, useEffect, useRef } from 'react';
import { Menu, X, MessageCircle, ArrowLeft, ChevronLeft, ChevronRight } from 'lucide-react';
import { ref, onValue } from 'firebase/database';
import { database } from './firebase';

const BBUserWebsite = () => {
  const [page, setPage] = useState('language');
  const [language, setLanguage] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // Popup states
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupDisclaimer, setPopupDisclaimer] = useState('');
  const femaleClicksRef = useRef([]);

  // Default site data with hardcoded social links
  const defaultSiteData = {
    logo: {
      url: 'https://i.ibb.co/p5FHHrc/IMG-7571.jpg'
    },
    socialLinks: {
      facebook: { url: 'https://www.facebook.com/bbbebeaute', customIcon: '' },
      tiktok: { url: 'https://www.tiktok.com/@bbbebeaute', customIcon: '' },
      shopee: { url: 'https://my.shp.ee/AtUcT6V', customIcon: '' },
      lazada: { url: 'https://s.lazada.com.my/s.unUaR', customIcon: '' },
      whatsapp: { url: 'https://wa.link/s8yuil', customIcon: '' }
    },
    languagePage: {
      subtitle_cn: '选择语言',
      subtitle_en: 'Choose Your Language'
    },
    genderPage: {
      title_cn: '请选择',
      title_en: 'Please Select',
      male_cn: '男士',
      male_en: 'Male',
      female_cn: '女士',
      female_en: 'Female'
    },
    popupMessages: {
      option1_cn: '在AI世界里女人除了18岁还是18岁 50-x=18 加减乘除X还是18 不会有错误 😄✨',
      option1_en: 'In the AI world, women are 18 and always 18! 50-x=18. Add, subtract, multiply, divide - X is still 18, never wrong! 😄✨',
      option2_cn: '只有有缘人能发现此等宝物，你走运了！🍀✨',
      option2_en: 'Only the destined ones can discover such treasures. You\'re lucky! 🍀✨',
      option3_cn: '你是好女人还是坏女人？我不懂但我只知道你是漂亮女人！😍',
      option3_en: 'Are you a good woman or a bad woman? I don\'t know, but I know you\'re a beautiful woman! 😍',
      option4_cn: '请支持我们的产品，不然服务器很快瘫痪！😅',
      option4_en: 'Please support our products, otherwise the server will crash! 😅',
      disclaimer_cn: '✨ 以上回复纯属AI娱乐，不代表本公司立场 ✨',
      disclaimer_en: '✨ The above is AI entertainment only, does not represent company views ✨',
      male_option1_cn: '欢迎男神！点到我们你注定成为男神！👑💪',
      male_option1_en: 'Welcome, handsome king! You\'re destined to become a real man! 👑💪',
      male_option2_cn: '当你好好照顾你兄弟，你兄弟也会照顾你🔥',
      male_option2_en: 'Take care of your little bro, and he\'ll take care of you! 🔥',
      male_option3_cn: '帅哥，你是来找宝物的吗？恭喜你找到了！✨',
      male_option3_en: 'Hey handsome, looking for treasures? Congratulations, you found it! ✨',
      male_option4_cn: '兄弟，你点太多次了！别玩了！😂',
      male_option4_en: 'Bro, you\'ve clicked too many times! Stop playing around! 😂',
      male_disclaimer_cn: '✨ 以上回复纯属AI娱乐，不代表本公司立场 ✨',
      male_disclaimer_en: '✨ The above is AI entertainment only, does not represent company views ✨'
    },
    menPage: {
      headline_cn: '提升生活质量，让女人对你念念不忘。',
      headline_en: 'Improve your quality of life, make women remember you.',
      subheadline_cn: '坏女人着迷，而你家女人自带飘逸因为实在太舒服',
      subheadline_en: 'Captivate women, bring satisfaction to your partner',
      product1_name_en: "MEN'S WASH",
      product1_subtitle_cn: '草本私密洁净露',
      productImages: [
        'https://i.ibb.co/N2wJWwqd/1.jpg',
        'https://i.ibb.co/cSccCR7v/2.jpg'
      ],
      packages: [
        { size: '200ml x1', price: 'RM 69.00', freeGift: '30ML x1', linkCn: 'https://wa.link/iwryvw', linkEn: 'https://wa.link/ibqohe' },
        { size: '200ml x2', price: 'RM 138.00', freeGift: '200ML x1', linkCn: 'https://wa.link/gul9qy', linkEn: 'https://wa.link/wkw01c' },
        { size: '30ml x1', price: 'RM 25.00', freeGift: '', linkCn: 'https://wa.link/s8yuil', linkEn: 'https://wa.link/s8yuil' }
      ],
      shipping: [
        { region_cn: '西马', region_en: 'West Malaysia', price: 'RM 5' },
        { region_cn: '东马', region_en: 'East Malaysia', price: 'RM 15' },
        { region_cn: '新加坡', region_en: 'Singapore', price: 'RM 25' }
      ]
    },
    womenPage: {
      headline_cn: '在你变得更美的同时气质的合金量也不断上升',
      headline_en: 'Become more beautiful while elevating your elegance',
      subheadline_cn: '让爱你的男人幸福，让渣男望尘莫及',
      subheadline_en: 'Bring happiness to those who love you, surpass all expectations',
      product1_name_en: 'FEMININE WASH',
      product1_name_cn: '草本私密洁净露',
      productImages: [
        'https://i.ibb.co/N2wJWwqd/1.jpg',
        'https://i.ibb.co/cSccCR7v/2.jpg'
      ],
      packages: [
        { size: '200ml x1', price: 'RM 69.00', freeGift: '30ML x1', linkCn: 'https://wa.link/iwryvw', linkEn: 'https://wa.link/ibqohe' },
        { size: '200ml x2', price: 'RM 138.00', freeGift: '200ML x1', linkCn: 'https://wa.link/gul9qy', linkEn: 'https://wa.link/wkw01c' },
        { size: '30ml x1', price: 'RM 25.00', freeGift: '', linkCn: 'https://wa.link/s8yuil', linkEn: 'https://wa.link/s8yuil' },
        { size: '', price: '', freeGift: '', linkCn: '', linkEn: '' }
      ],
      shipping: [
        { region_cn: '西马', region_en: 'West Malaysia', price: 'RM 5' },
        { region_cn: '东马', region_en: 'East Malaysia', price: 'RM 15' },
        { region_cn: '新加坡', region_en: 'Singapore', price: 'RM 25' }
      ]
    },
    productPage: {
      title_cn: '我们的产品',
      title_en: 'Our Products',
      certificates_title_cn: '相关文件',
      certificates_title_en: 'Company Documents',
      products: [
        { name_cn: '草本私密洁净露', name_en: 'Feminine Wash', price: 'RM 69.00', image: 'https://i.ibb.co/N2wJWwqd/1.jpg' },
        { name_cn: '产品特点', name_en: 'Product Features', price: '', image: 'https://i.ibb.co/cSccCR7v/2.jpg' }
      ],
      certificates: [
        { title_cn: '马来西亚卫生部认证', title_en: 'MOH Malaysia Notification', image: 'https://i.ibb.co/qL6rqyCh/IMG-7815.jpg' },
        { title_cn: '检验分析证书', title_en: 'Certificate of Analysis', image: 'https://i.ibb.co/mF4WC9LQ/IMG-7813.jpg' }
      ]
    },
    partnersPage: {
      title_cn: '我们的伙伴',
      title_en: 'Our Partners',
      subtitle_cn: '感谢以下伙伴的支持',
      subtitle_en: 'Thanks to our amazing partners',
      partners: []
    },
    whatsappNumber: '1234567890'
  };

  const [siteData, setSiteData] = useState(defaultSiteData);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Listen for real-time updates from Firebase
    const siteDataRef = ref(database, 'siteData');
    const unsubscribe = onValue(siteDataRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        // Deep merge with defaults
        setSiteData(prev => {
          const merged = { ...defaultSiteData };
          Object.keys(data).forEach(key => {
            if (typeof data[key] === 'object' && data[key] !== null && !Array.isArray(data[key])) {
              merged[key] = { ...defaultSiteData[key], ...data[key] };
            } else {
              merged[key] = data[key];
            }
          });
          return merged;
        });
      }
      setIsLoading(false);
    }, (error) => {
      console.error('Firebase read error:', error);
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Handle language selection
  const handleLanguageSelect = (lang) => {
    setLanguage(lang);
    setPage('gender');
  };

  // Track last shown option to avoid repeats
  const lastOptionRef = useRef(0);
  const lastMaleOptionRef = useRef(0);
  const maleClicksRef = useRef([]);
  const [popupType, setPopupType] = useState('female'); // 'female' or 'male'

  // Handle female button click with popup
  const handleFemaleClick = () => {
    const now = Date.now();
    
    // Track clicks within last 60 seconds
    femaleClicksRef.current = femaleClicksRef.current.filter(
      timestamp => now - timestamp < 60000
    );
    femaleClicksRef.current.push(now);
    
    // Check if clicked 4+ times in 1 minute - show Option 4
    const recentClicks = femaleClicksRef.current.length;
    
    let option;
    if (recentClicks >= 4) {
      // Show option 4 (spam warning)
      option = 4;
      femaleClicksRef.current = []; // Reset
      lastOptionRef.current = 0; // Reset last option
    } else {
      // 100% show popup - pick random option 1, 2, or 3 (different from last)
      const availableOptions = [1, 2, 3].filter(opt => opt !== lastOptionRef.current);
      option = availableOptions[Math.floor(Math.random() * availableOptions.length)];
      lastOptionRef.current = option; // Remember this option
    }
    
    // Get message based on language and option
    const messages = siteData.popupMessages || defaultSiteData.popupMessages;
    const langSuffix = language === 'chinese' ? '_cn' : '_en';
    
    setPopupMessage(messages[`option${option}${langSuffix}`] || '');
    setPopupDisclaimer(messages[`disclaimer${langSuffix}`] || '');
    setPopupType('female');
    setShowPopup(true);
  };

  // Handle male button click with popup
  const handleMaleClick = () => {
    const now = Date.now();
    
    // Track clicks within last 60 seconds
    maleClicksRef.current = maleClicksRef.current.filter(
      timestamp => now - timestamp < 60000
    );
    maleClicksRef.current.push(now);
    
    // Check if clicked 4+ times in 1 minute - show Option 4
    const recentClicks = maleClicksRef.current.length;
    
    let option;
    if (recentClicks >= 4) {
      // Show option 4 (spam warning)
      option = 4;
      maleClicksRef.current = []; // Reset
      lastMaleOptionRef.current = 0; // Reset last option
    } else {
      // 100% show popup - pick random option 1, 2, or 3 (different from last)
      const availableOptions = [1, 2, 3].filter(opt => opt !== lastMaleOptionRef.current);
      option = availableOptions[Math.floor(Math.random() * availableOptions.length)];
      lastMaleOptionRef.current = option; // Remember this option
    }
    
    // Get message based on language and option
    const messages = siteData.popupMessages || defaultSiteData.popupMessages;
    const langSuffix = language === 'chinese' ? '_cn' : '_en';
    
    const msg = messages[`male_option${option}${langSuffix}`] || '';
    const disc = messages[`male_disclaimer${langSuffix}`] || '';
    
    // If no male messages set, go directly to men page
    if (!msg) {
      setPage('men');
      return;
    }
    
    setPopupMessage(msg);
    setPopupDisclaimer(disc);
    setPopupType('male');
    setShowPopup(true);
  };

  // Popup Component
  const PopupMessage = () => {
    if (!showPopup) return null;
    
    const isMale = popupType === 'male';
    const bgGradient = isMale 
      ? 'linear-gradient(135deg, #e0f2fe, #cffafe)' 
      : 'linear-gradient(135deg, #fce7f3, #fecdd3)';
    const textColor = isMale ? '#0284c7' : '#db2777';
    const buttonBg = isMale 
      ? 'linear-gradient(135deg, #0ea5e9, #0284c7)' 
      : 'linear-gradient(135deg, #ec4899, #db2777)';
    const buttonShadow = isMale 
      ? '0 5px 20px rgba(2, 132, 199, 0.4)' 
      : '0 5px 20px rgba(219, 39, 119, 0.4)';
    const emoji = isMale ? '💪' : '💕';
    const continueEmoji = isMale ? '💪' : '❤️';
    const targetPage = isMale ? 'men' : 'women';
    
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        padding: '20px'
      }} onClick={() => {
        setShowPopup(false);
        setPage(targetPage);
      }}>
        <div style={{
          background: bgGradient,
          borderRadius: '20px',
          padding: '30px',
          maxWidth: '400px',
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          animation: 'popIn 0.3s ease'
        }} onClick={e => e.stopPropagation()}>
          <div style={{
            fontSize: '50px',
            marginBottom: '15px'
          }}>
            {emoji}
          </div>
          <p style={{
            fontSize: '18px',
            color: textColor,
            fontWeight: '600',
            marginBottom: '15px',
            lineHeight: '1.6',
            whiteSpace: 'pre-line'
          }}>
            {popupMessage}
          </p>
          <p style={{
            fontSize: '12px',
            color: '#888',
            fontStyle: 'italic',
            marginBottom: '20px'
          }}>
            {popupDisclaimer}
          </p>
          <button
            onClick={() => {
              setShowPopup(false);
              setPage(targetPage);
            }}
            style={{
              background: buttonBg,
              color: 'white',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '25px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: buttonShadow
            }}
          >
            {language === 'chinese' ? `继续 ${continueEmoji}` : `Continue ${continueEmoji}`}
          </button>
        </div>
      </div>
    );
  };

  // Styles
  const styles = {
    pageContainer: {
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    card: {
      background: 'white',
      borderRadius: '20px',
      boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
      padding: '30px',
      marginBottom: '20px'
    },
    button: {
      padding: '18px 30px',
      borderRadius: '15px',
      border: '2px solid #e0e0e0',
      cursor: 'pointer',
      fontSize: '20px',
      transition: 'all 0.3s ease',
      width: '100%',
      marginBottom: '15px',
      background: 'white'
    },
    header: {
      background: 'rgba(255,255,255,0.95)',
      boxShadow: '0 2px 15px rgba(0,0,0,0.08)',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      padding: '10px 15px'
    },
    logo: {
      width: '100px',
      height: '100px',
      objectFit: 'contain',
      cursor: 'pointer'
    },
    socialIcon: {
      width: '36px',
      height: '36px',
      borderRadius: '10px',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: 'white',
      fontWeight: 'bold',
      fontSize: '12px',
      marginLeft: '8px'
    },
    navButton: {
      padding: '12px 28px',
      borderRadius: '25px',
      border: 'none',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '600',
      margin: '5px',
      transition: 'all 0.3s'
    },
    productCard: {
      borderRadius: '20px',
      boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
      padding: '25px',
      marginBottom: '25px'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
      background: 'white'
    },
    tableHeader: {
      padding: '15px',
      textAlign: 'center',
      fontSize: '14px',
      fontWeight: '600',
      color: 'white'
    },
    tableCell: {
      padding: '14px',
      textAlign: 'center',
      borderBottom: '1px solid #eee'
    },
    giftBadge: {
      color: 'white',
      padding: '6px 12px',
      borderRadius: '6px',
      fontSize: '12px',
      fontWeight: 'bold',
      display: 'inline-block'
    },
    whatsappButton: {
      position: 'fixed',
      bottom: '25px',
      right: '25px',
      background: '#25D366',
      color: 'white',
      width: '60px',
      height: '60px',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: '0 5px 25px rgba(37,211,102,0.4)',
      cursor: 'pointer',
      zIndex: 1000,
      border: 'none',
      textDecoration: 'none'
    }
  };

  // Social Icons with SVG
  const SocialIcons = () => {
    const icons = {
      facebook: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      tiktok: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
          <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
        </svg>
      ),
      shopee: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
          <path d="M12 2C9.243 2 7 4.243 7 7h2c0-1.654 1.346-3 3-3s3 1.346 3 3h2c0-2.757-2.243-5-5-5zM5 7v2h14V7H5zm-1 4l1.5 11h13L20 11H4zm8 2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3z"/>
        </svg>
      ),
      lazada: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
        </svg>
      ),
      whatsapp: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      )
    };

    const platforms = [
      { key: 'facebook', color: '#1877F2' },
      { key: 'tiktok', color: '#000000' },
      { key: 'shopee', color: '#EE4D2D' },
      { key: 'lazada', color: 'transparent', customIcon: 'https://i.ibb.co/ynrvZJht/2211.webp' },
      { key: 'whatsapp', color: '#25D366' }
    ];

    return (
      <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
        {platforms.map(p => {
          // Get URL from siteData - WhatsApp now uses direct URL
          let url = '';
          if (siteData.socialLinks && siteData.socialLinks[p.key]) {
            url = siteData.socialLinks[p.key].url || '';
          }
          
          // Auto-add https:// if missing (but not for URLs that already have protocol)
          if (url && url.length > 0 && !url.startsWith('http://') && !url.startsWith('https://')) {
            url = 'https://' + url;
          }

          // Check if URL exists
          const hasUrl = url && url.length > 0 && url !== 'https://';
          
          // For mobile compatibility, use actual URL or javascript:void(0)
          const finalHref = hasUrl ? url : 'javascript:void(0)';

          return (
            <a
              key={p.key}
              href={finalHref}
              target={hasUrl ? "_blank" : "_self"}
              rel={hasUrl ? "noopener noreferrer" : undefined}
              style={{ 
                width: '40px',
                height: '40px',
                borderRadius: '10px',
                cursor: hasUrl ? 'pointer' : 'default',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'white',
                background: p.color,
                textDecoration: 'none',
                WebkitTapHighlightColor: 'transparent',
                touchAction: 'manipulation',
                opacity: hasUrl ? 1 : 0.6
              }}
            >
              {p.customIcon ? (
                <img src={p.customIcon} alt={p.key} style={{ width: '100%', height: '100%', borderRadius: '10px', objectFit: 'cover', pointerEvents: 'none' }} />
              ) : siteData.socialLinks[p.key]?.customIcon ? (
                <img src={siteData.socialLinks[p.key].customIcon} alt={p.key} style={{ width: '100%', height: '100%', borderRadius: '10px', pointerEvents: 'none' }} />
              ) : <span style={{ pointerEvents: 'none' }}>{icons[p.key]}</span>}
            </a>
          );
        })}
      </div>
    );
  };

  // Image Slider Component with auto-slide and touch swipe
  const ImageSlider = ({ images, accentColor = '#9333ea' }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const sliderRef = useRef(null);
    
    // Auto slide every 4 seconds
    useEffect(() => {
      if (images.length <= 1) return;
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
      }, 4000);
      return () => clearInterval(interval);
    }, [images.length]);

    // Touch handlers for swipe
    const minSwipeDistance = 50;

    const onTouchStart = (e) => {
      setTouchEnd(null);
      setTouchStart(e.targetTouches[0].clientX);
    };

    const onTouchMove = (e) => {
      setTouchEnd(e.targetTouches[0].clientX);
    };

    const onTouchEnd = () => {
      if (!touchStart || !touchEnd) return;
      const distance = touchStart - touchEnd;
      const isLeftSwipe = distance > minSwipeDistance;
      const isRightSwipe = distance < -minSwipeDistance;
      
      if (isLeftSwipe) {
        setCurrentIndex((prev) => (prev + 1) % images.length);
      }
      if (isRightSwipe) {
        setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
      }
    };

    const goToSlide = (index) => setCurrentIndex(index);
    const goToPrev = () => setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    const goToNext = () => setCurrentIndex((prev) => (prev + 1) % images.length);

    if (!images || images.length === 0) return null;

    return (
      <div style={{ marginBottom: '20px', position: 'relative', maxWidth: '500px', margin: '0 auto 20px' }}>
        {/* Main Slider */}
        <div 
          ref={sliderRef}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          style={{ 
            position: 'relative',
            overflow: 'hidden', 
            borderRadius: '16px',
            boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
            background: '#f5f5f5'
          }}
        >
          <div style={{
            display: 'flex',
            transition: 'transform 0.5s ease-in-out',
            transform: `translateX(-${currentIndex * 100}%)`
          }}>
            {images.map((img, idx) => (
              <div key={idx} style={{ 
                minWidth: '100%', 
                flexShrink: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <img 
                  src={img} 
                  alt={`Slide ${idx + 1}`} 
                  style={{ 
                    width: '100%', 
                    height: 'auto', 
                    display: 'block',
                    objectFit: 'contain'
                  }} 
                />
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          {images.length > 1 && (
            <>
              <button 
                onClick={goToPrev}
                style={{
                  position: 'absolute',
                  left: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'rgba(255,255,255,0.85)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  zIndex: 10
                }}
              >
                <ChevronLeft size={20} color="#333" />
              </button>
              <button 
                onClick={goToNext}
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'rgba(255,255,255,0.85)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  zIndex: 10
                }}
              >
                <ChevronRight size={20} color="#333" />
              </button>
            </>
          )}

          {/* Slide Counter */}
          {images.length > 1 && (
            <div style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              background: 'rgba(0,0,0,0.5)',
              color: 'white',
              padding: '4px 10px',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '600'
            }}>
              {currentIndex + 1} / {images.length}
            </div>
          )}
        </div>

        {/* Dots Indicator */}
        {images.length > 1 && (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: '8px', 
            marginTop: '15px' 
          }}>
            {images.map((_, idx) => (
              <button
                key={idx}
                onClick={() => goToSlide(idx)}
                style={{
                  width: currentIndex === idx ? '24px' : '10px',
                  height: '10px',
                  borderRadius: '5px',
                  border: 'none',
                  background: currentIndex === idx ? accentColor : '#ddd',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  padding: 0
                }}
              />
            ))}
          </div>
        )}
      </div>
    );
  };

  // Language Page
  const LanguagePage = () => (
    <div style={{ ...styles.pageContainer, background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
      <div style={{ ...styles.card, maxWidth: '450px', width: '100%', textAlign: 'center' }}>
        <div style={{ width: '180px', height: '180px', margin: '0 auto 20px', borderRadius: '50%', overflow: 'hidden', background: 'white', padding: '10px', boxShadow: '0 5px 20px rgba(0,0,0,0.1)' }}>
          <img src={siteData.logo.url} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </div>
        <div style={{ width: '80px', height: '4px', background: 'linear-gradient(90deg, #9333ea, #ec4899)', margin: '0 auto 20px', borderRadius: '2px' }}></div>
        <p style={{ color: '#888', marginBottom: '30px', fontSize: '16px' }}>{siteData.languagePage.subtitle_en} / {siteData.languagePage.subtitle_cn}</p>
        <button onClick={() => handleLanguageSelect('chinese')} style={styles.button}>中文</button>
        <button onClick={() => handleLanguageSelect('english')} style={{ ...styles.button, fontFamily: 'Georgia, serif' }}>English</button>
      </div>
    </div>
  );

  // Gender Page
  const GenderPage = () => (
    <div style={{ ...styles.pageContainer, background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)', padding: '40px 20px' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
        <div style={{ width: '180px', height: '180px', margin: '0 auto 20px', borderRadius: '50%', overflow: 'hidden', background: 'white', padding: '10px', boxShadow: '0 5px 20px rgba(0,0,0,0.1)' }}>
          <img src={siteData.logo.url} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </div>
        <div style={{ width: '80px', height: '4px', background: 'linear-gradient(90deg, #9333ea, #ec4899)', margin: '0 auto 20px', borderRadius: '2px' }}></div>
        <p style={{ color: '#888', marginBottom: '40px', fontSize: '18px' }}>{language === 'chinese' ? siteData.genderPage.title_cn : siteData.genderPage.title_en}</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '25px' }}>
          {/* Male */}
          <div onClick={handleMaleClick} style={{ ...styles.card, cursor: 'pointer', background: 'linear-gradient(135deg, #e0f2fe, #cffafe)', padding: '40px 30px' }}>
            <svg width="80" height="100" viewBox="0 0 100 140" style={{ margin: '0 auto 20px', display: 'block' }}>
              <circle cx="50" cy="18" r="16" fill="#0ea5e9"/>
              <path d="M50 34 L50 80" stroke="#0ea5e9" strokeWidth="16" strokeLinecap="round"/>
              <path d="M50 45 L25 70" stroke="#0ea5e9" strokeWidth="12" strokeLinecap="round"/>
              <path d="M50 45 L75 70" stroke="#0ea5e9" strokeWidth="12" strokeLinecap="round"/>
              <path d="M50 80 L30 120" stroke="#0ea5e9" strokeWidth="12" strokeLinecap="round"/>
              <path d="M50 80 L70 120" stroke="#0ea5e9" strokeWidth="12" strokeLinecap="round"/>
            </svg>
            <span style={{ fontSize: '28px', color: '#0284c7', fontWeight: '500' }}>{language === 'chinese' ? siteData.genderPage.male_cn : siteData.genderPage.male_en}</span>
          </div>
          {/* Female */}
          <div onClick={handleFemaleClick} style={{ ...styles.card, cursor: 'pointer', background: 'linear-gradient(135deg, #fce7f3, #fecdd3)', padding: '40px 30px' }}>
            <svg width="80" height="100" viewBox="0 0 100 140" style={{ margin: '0 auto 20px', display: 'block' }}>
              <circle cx="50" cy="18" r="16" fill="#ec4899"/>
              <path d="M50 34 L50 55" stroke="#ec4899" strokeWidth="14" strokeLinecap="round"/>
              <path d="M30 95 L50 55 L70 95 Z" fill="#ec4899"/>
              <path d="M50 42 L28 68" stroke="#ec4899" strokeWidth="10" strokeLinecap="round"/>
              <path d="M50 42 L72 68" stroke="#ec4899" strokeWidth="10" strokeLinecap="round"/>
              <path d="M40 95 L35 125" stroke="#ec4899" strokeWidth="10" strokeLinecap="round"/>
              <path d="M60 95 L65 125" stroke="#ec4899" strokeWidth="10" strokeLinecap="round"/>
            </svg>
            <span style={{ fontSize: '28px', color: '#db2777', fontWeight: '500' }}>{language === 'chinese' ? siteData.genderPage.female_cn : siteData.genderPage.female_en}</span>
          </div>
        </div>
        
        {/* Language Toggle */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', marginTop: '40px' }}>
          <button 
            onClick={() => setLanguage('chinese')} 
            style={{ 
              padding: '12px 28px', 
              borderRadius: '25px', 
              border: 'none',
              background: language === 'chinese' ? 'linear-gradient(135deg, #9333ea, #ec4899)' : 'white',
              color: language === 'chinese' ? 'white' : '#666',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: language === 'chinese' ? '0 5px 20px rgba(147, 51, 234, 0.4)' : '0 3px 10px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease'
            }}
          >
            中文
          </button>
          <button 
            onClick={() => setLanguage('english')} 
            style={{ 
              padding: '12px 28px', 
              borderRadius: '25px', 
              border: 'none',
              background: language === 'english' ? 'linear-gradient(135deg, #9333ea, #ec4899)' : 'white',
              color: language === 'english' ? 'white' : '#666',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: language === 'english' ? '0 5px 20px rgba(147, 51, 234, 0.4)' : '0 3px 10px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease'
            }}
          >
            English
          </button>
        </div>
      </div>
      <PopupMessage />
    </div>
  );

  // Header
  const Header = ({ currentPage }) => (
    <div style={styles.header}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '15px' }}>
          <img src={siteData.logo.url} alt="Logo" style={styles.logo} onClick={() => setPage('language')} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
          <button onClick={() => setPage('gender')} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px' }}>
            <ArrowLeft size={24} color="#333" />
          </button>
          <SocialIcons />
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px' }}>
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button onClick={() => setPage('men')} style={{ ...styles.navButton, background: currentPage === 'men' ? 'linear-gradient(135deg, #0ea5e9, #06b6d4)' : '#f0f0f0', color: currentPage === 'men' ? 'white' : '#333' }}>
            {language === 'chinese' ? '男士' : 'Men'}
          </button>
          <button onClick={() => setPage('women')} style={{ ...styles.navButton, background: currentPage === 'women' ? 'linear-gradient(135deg, #ec4899, #f43f5e)' : '#f0f0f0', color: currentPage === 'women' ? 'white' : '#333' }}>
            {language === 'chinese' ? '女士' : 'Women'}
          </button>
          <button onClick={() => setPage('product')} style={{ ...styles.navButton, background: currentPage === 'product' ? 'linear-gradient(135deg, #9333ea, #ec4899)' : '#f0f0f0', color: currentPage === 'product' ? 'white' : '#333' }}>
            {language === 'chinese' ? '产品' : 'Product'}
          </button>
          <button onClick={() => setPage('partners')} style={{ ...styles.navButton, background: currentPage === 'partners' ? 'linear-gradient(135deg, #f97316, #fb923c)' : '#f0f0f0', color: currentPage === 'partners' ? 'white' : '#333' }}>
            {language === 'chinese' ? '伙伴' : 'Partners'}
          </button>
        </div>
        {mobileMenuOpen && (
          <div style={{ marginTop: '15px', padding: '15px', background: '#f8f9fa', borderRadius: '15px' }}>
            <button onClick={() => { setPage('men'); setMobileMenuOpen(false); }} style={{ ...styles.button, background: 'linear-gradient(135deg, #0ea5e9, #06b6d4)', color: 'white', border: 'none' }}>Men / 男士</button>
            <button onClick={() => { setPage('women'); setMobileMenuOpen(false); }} style={{ ...styles.button, background: 'linear-gradient(135deg, #ec4899, #f43f5e)', color: 'white', border: 'none' }}>Women / 女士</button>
            <button onClick={() => { setPage('product'); setMobileMenuOpen(false); }} style={{ ...styles.button, background: '#f0f0f0', color: '#333' }}>Product / 产品</button>
            <button onClick={() => { setPage('partners'); setMobileMenuOpen(false); }} style={{ ...styles.button, background: 'linear-gradient(135deg, #f97316, #fb923c)', color: 'white', border: 'none' }}>Partners / 伙伴</button>
          </div>
        )}
      </div>
    </div>
  );

  // WhatsApp Button
  const WhatsAppButton = () => (
    <a href={`https://wa.me/${siteData.whatsappNumber}`} target="_blank" rel="noopener noreferrer" style={styles.whatsappButton}>
      <MessageCircle size={28} />
    </a>
  );

  // Men's Page
  const MenPage = () => (
    <div style={{ ...styles.pageContainer, background: 'linear-gradient(135deg, #e0f2fe, #cffafe)' }}>
      <Header currentPage="men" />
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
        <div style={styles.card}>
          <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#333', marginBottom: '10px', marginTop: 0 }}>
            {language === 'chinese' ? siteData.menPage.headline_cn : siteData.menPage.headline_en}
          </h2>
          <p style={{ color: '#666', margin: 0 }}>{language === 'chinese' ? siteData.menPage.subheadline_cn : siteData.menPage.subheadline_en}</p>
        </div>

        {/* Product Images Slider */}
        {(() => {
          const images = language === 'chinese' 
            ? (siteData.menPage.productImages || []) 
            : (siteData.menPage.productImagesEn && siteData.menPage.productImagesEn.length > 0 
                ? siteData.menPage.productImagesEn 
                : siteData.menPage.productImages || []);
          return <ImageSlider images={images} accentColor="#0ea5e9" />;
        })()}

        <div style={{ ...styles.productCard, background: 'linear-gradient(135deg, #e0f2fe, #cffafe, #e0f7fe)' }}>
          <div style={{ marginBottom: '20px' }}>
            <h3 style={{ fontSize: '26px', fontWeight: 'bold', color: '#0284c7', margin: '0 0 5px' }}>{siteData.menPage.product1_name_en}</h3>
            <p style={{ fontSize: '20px', color: '#0ea5e9', margin: '0 0 5px' }}>{siteData.menPage.product1_subtitle_cn}</p>
            <p style={{ fontSize: '16px', fontWeight: '600', color: '#0369a1', margin: 0 }}>PACKAGE 配套</p>
          </div>
          <table style={{ ...styles.table, marginBottom: '20px' }}>
            <thead>
              <tr>
                <th style={{ ...styles.tableHeader, background: '#0284c7' }}>PACKAGE<br/><span style={{ fontSize: '11px', fontWeight: 'normal' }}>套装内容</span></th>
                <th style={{ ...styles.tableHeader, background: '#0284c7' }}>PRICE<br/><span style={{ fontSize: '11px', fontWeight: 'normal' }}>价格</span></th>
                <th style={{ ...styles.tableHeader, background: '#0284c7' }}>FREE<br/><span style={{ fontSize: '11px', fontWeight: 'normal' }}>赠品</span></th>
              </tr>
            </thead>
            <tbody>
              {siteData.menPage.packages.map((pkg, idx) => {
                // Get WhatsApp link from package data
                let link = language === 'chinese' ? pkg.linkCn : pkg.linkEn;
                
                // Auto-add https:// if missing
                if (link && !link.startsWith('http://') && !link.startsWith('https://')) {
                  link = 'https://' + link;
                }
                
                return (
                  <tr 
                    key={idx} 
                    onClick={() => link && window.open(link, '_blank')}
                    style={{ cursor: link ? 'pointer' : 'default' }}
                  >
                    <td style={{ ...styles.tableCell, background: idx % 2 === 0 ? '#f0f9ff' : 'white' }}><strong>{pkg.size}</strong></td>
                    <td style={{ ...styles.tableCell, background: idx % 2 === 0 ? '#f0f9ff' : 'white', color: '#0284c7', fontWeight: 'bold', fontSize: '16px' }}>
                      {link ? <span style={{ textDecoration: 'underline' }}>{pkg.price}</span> : pkg.price}
                    </td>
                    <td style={{ ...styles.tableCell, background: idx % 2 === 0 ? '#f0f9ff' : 'white' }}>
                      {pkg.freeGift ? <span style={{ ...styles.giftBadge, background: '#0284c7' }}>🎁 {pkg.freeGift}</span> : '-'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <table style={styles.table}>
            <thead>
              <tr><th colSpan="3" style={{ ...styles.tableHeader, background: '#0284c7' }}>SHIPPING FEE 运费说明</th></tr>
            </thead>
            <tbody>
              <tr>
                {siteData.menPage.shipping.map((ship, idx) => (
                  <td key={idx} style={{ ...styles.tableCell, background: '#f0f9ff', padding: '15px' }}>
                    <div style={{ fontSize: '12px', color: '#666' }}>{ship.region_en}<br/>{ship.region_cn}</div>
                    <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#0284c7', marginTop: '5px' }}>{ship.price}</div>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <WhatsAppButton />
    </div>
  );

  // Women's Page
  const WomenPage = () => (
    <div style={{ ...styles.pageContainer, background: 'linear-gradient(135deg, #fce7f3, #fecdd3)' }}>
      <Header currentPage="women" />
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
        <div style={styles.card}>
          <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#333', marginBottom: '10px', marginTop: 0 }}>
            {language === 'chinese' ? siteData.womenPage.headline_cn : siteData.womenPage.headline_en}
          </h2>
          <p style={{ color: '#666', margin: 0 }}>{language === 'chinese' ? siteData.womenPage.subheadline_cn : siteData.womenPage.subheadline_en}</p>
        </div>

        {/* Product Images Slider */}
        {(() => {
          const images = language === 'chinese' 
            ? (siteData.womenPage.productImages || []) 
            : (siteData.womenPage.productImagesEn && siteData.womenPage.productImagesEn.length > 0 
                ? siteData.womenPage.productImagesEn 
                : siteData.womenPage.productImages || []);
          return <ImageSlider images={images} accentColor="#ec4899" />;
        })()}

        <div style={{ ...styles.productCard, background: 'linear-gradient(135deg, #fce7f3, #fecdd3, #ffe4e6)' }}>
          <div style={{ marginBottom: '20px' }}>
            <h3 style={{ fontSize: '26px', fontWeight: 'bold', color: '#db2777', margin: '0 0 5px' }}>{siteData.womenPage.product1_name_en}</h3>
            <p style={{ fontSize: '20px', color: '#ec4899', margin: '0 0 5px' }}>{siteData.womenPage.product1_name_cn}</p>
            <p style={{ fontSize: '16px', fontWeight: '600', color: '#be185d', margin: 0 }}>PACKAGE 配套</p>
          </div>
          <table style={{ ...styles.table, marginBottom: '20px' }}>
            <thead>
              <tr>
                <th style={{ ...styles.tableHeader, background: '#db2777' }}>PACKAGE<br/><span style={{ fontSize: '11px', fontWeight: 'normal' }}>套装内容</span></th>
                <th style={{ ...styles.tableHeader, background: '#db2777' }}>PRICE<br/><span style={{ fontSize: '11px', fontWeight: 'normal' }}>价格</span></th>
                <th style={{ ...styles.tableHeader, background: '#db2777' }}>FREE<br/><span style={{ fontSize: '11px', fontWeight: 'normal' }}>赠品</span></th>
              </tr>
            </thead>
            <tbody>
              {siteData.womenPage.packages.map((pkg, idx) => {
                // Get WhatsApp link from package data
                let link = language === 'chinese' ? pkg.linkCn : pkg.linkEn;
                
                // Auto-add https:// if missing
                if (link && !link.startsWith('http://') && !link.startsWith('https://')) {
                  link = 'https://' + link;
                }
                
                return (
                  <tr 
                    key={idx} 
                    onClick={() => link && window.open(link, '_blank')}
                    style={{ cursor: link ? 'pointer' : 'default' }}
                  >
                    <td style={{ ...styles.tableCell, background: idx % 2 === 0 ? '#fdf2f8' : 'white' }}><strong>{pkg.size}</strong></td>
                    <td style={{ ...styles.tableCell, background: idx % 2 === 0 ? '#fdf2f8' : 'white', color: '#db2777', fontWeight: 'bold', fontSize: '16px' }}>
                      {link ? <span style={{ textDecoration: 'underline' }}>{pkg.price}</span> : pkg.price}
                    </td>
                    <td style={{ ...styles.tableCell, background: idx % 2 === 0 ? '#fdf2f8' : 'white' }}>
                      {pkg.freeGift ? <span style={{ ...styles.giftBadge, background: '#ef4444' }}>🎁 {pkg.freeGift}</span> : '-'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <table style={styles.table}>
            <thead>
              <tr><th colSpan="3" style={{ ...styles.tableHeader, background: '#db2777' }}>SHIPPING FEE 运费说明</th></tr>
            </thead>
            <tbody>
              <tr>
                {siteData.womenPage.shipping.map((ship, idx) => (
                  <td key={idx} style={{ ...styles.tableCell, background: '#fdf2f8', padding: '15px' }}>
                    <div style={{ fontSize: '12px', color: '#666' }}>{ship.region_en}<br/>{ship.region_cn}</div>
                    <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#db2777', marginTop: '5px' }}>{ship.price}</div>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <WhatsAppButton />
    </div>
  );

  // Product Page
  const ProductPage = () => (
    <div style={{ ...styles.pageContainer, background: 'linear-gradient(135deg, #f3e8ff, #fce7f3)' }}>
      <Header currentPage="product" />
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
        <h2 style={{ textAlign: 'center', fontSize: '28px', fontWeight: 'bold', color: '#9333ea', marginBottom: '30px' }}>
          {language === 'chinese' ? siteData.productPage.title_cn : siteData.productPage.title_en}
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '25px', marginBottom: '30px' }}>
          {siteData.productPage.products.map((product, idx) => {
            const productImage = language === 'chinese' 
              ? product.image 
              : (product.imageEn || product.image);
            return (
              <div key={idx} style={{ ...styles.card, padding: 0, overflow: 'hidden' }}>
                {productImage ? (
                  <img src={productImage} alt={product.name_en} style={{ width: '100%', height: 'auto', display: 'block' }} />
                ) : (
                  <div style={{ fontSize: '48px', textAlign: 'center', padding: '40px' }}>{idx === 0 ? '🌟' : '💫'}</div>
                )}
                {(product.name_cn || product.price) && (
                  <div style={{ padding: '20px', textAlign: 'center', background: 'white' }}>
                    <p style={{ fontWeight: 'bold', marginBottom: '5px', margin: 0 }}>{language === 'chinese' ? product.name_cn : product.name_en}</p>
                    {product.price && <p style={{ fontSize: '20px', fontWeight: 'bold', color: '#22c55e', margin: '10px 0 0' }}>{product.price}</p>}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div style={styles.card}>
          <h3 style={{ fontSize: '22px', fontWeight: 'bold', textAlign: 'center', marginTop: 0, marginBottom: '20px' }}>
            {language === 'chinese' ? siteData.productPage.certificates_title_cn : siteData.productPage.certificates_title_en}
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
            {siteData.productPage.certificates.map((cert, idx) => (
              <div key={idx} style={{ background: '#f8f9fa', borderRadius: '15px', padding: '15px', textAlign: 'center' }}>
                <img src={cert.image} alt={cert.title_en} style={{ width: '100%', borderRadius: '10px', marginBottom: '10px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }} />
                <p style={{ fontWeight: '600', color: '#555', margin: 0 }}>{language === 'chinese' ? cert.title_cn : cert.title_en}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <WhatsAppButton />
    </div>
  );

  // Partners Page
  const PartnersPage = () => (
    <div style={{ ...styles.pageContainer, background: 'linear-gradient(135deg, #fff7ed, #ffedd5)' }}>
      <Header currentPage="partners" />
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
        <h2 style={{ textAlign: 'center', fontSize: '28px', fontWeight: 'bold', color: '#f97316', marginBottom: '10px' }}>
          {language === 'chinese' ? siteData.partnersPage?.title_cn || '我们的伙伴' : siteData.partnersPage?.title_en || 'Our Partners'}
        </h2>
        <p style={{ textAlign: 'center', color: '#666', marginBottom: '30px' }}>
          {language === 'chinese' ? siteData.partnersPage?.subtitle_cn || '感谢以下伙伴的支持' : siteData.partnersPage?.subtitle_en || 'Thanks to our amazing partners'}
        </p>
        
        {siteData.partnersPage?.partners && siteData.partnersPage.partners.length > 0 ? (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '25px' }}>
            {siteData.partnersPage.partners.map((partner, idx) => {
              let url = partner.url || '';
              if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
                url = 'https://' + url;
              }
              
              return (
                <div 
                  key={idx} 
                  onClick={() => url && window.open(url, '_blank')}
                  style={{ 
                    ...styles.card, 
                    textAlign: 'center', 
                    cursor: url ? 'pointer' : 'default',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 15px 50px rgba(249,115,22,0.2)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.1)';
                  }}
                >
                  {partner.photo ? (
                    <img 
                      src={partner.photo} 
                      alt={partner.name} 
                      style={{ 
                        width: '120px', 
                        height: '120px', 
                        borderRadius: '50%', 
                        objectFit: 'cover', 
                        margin: '0 auto 15px',
                        border: '4px solid #f97316',
                        boxShadow: '0 5px 20px rgba(249,115,22,0.3)'
                      }} 
                    />
                  ) : (
                    <div style={{ 
                      width: '120px', 
                      height: '120px', 
                      borderRadius: '50%', 
                      background: 'linear-gradient(135deg, #f97316, #fb923c)', 
                      margin: '0 auto 15px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '48px'
                    }}>
                      👤
                    </div>
                  )}
                  <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#333', margin: '0 0 10px' }}>
                    {partner.name || `Partner ${idx + 1}`}
                  </h3>
                  {url && (
                    <span style={{ 
                      fontSize: '14px', 
                      color: '#f97316', 
                      textDecoration: 'underline' 
                    }}>
                      {language === 'chinese' ? '点击访问 →' : 'Visit →'}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div style={{ ...styles.card, textAlign: 'center', padding: '60px 20px' }}>
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>🤝</div>
            <p style={{ color: '#666', fontSize: '18px' }}>
              {language === 'chinese' ? '暂无伙伴信息' : 'No partners yet'}
            </p>
          </div>
        )}
      </div>
      <WhatsAppButton />
    </div>
  );

  return (
    <div>
      {page === 'language' && <LanguagePage />}
      {page === 'gender' && <GenderPage />}
      {page === 'men' && <MenPage />}
      {page === 'women' && <WomenPage />}
      {page === 'product' && <ProductPage />}
      {page === 'partners' && <PartnersPage />}
    </div>
  );
};

export default BBUserWebsite;
